<template>
    <div class="explore-filter">

        <!-- Region Filter -->
        <div class="explore-filter__section">
            <div class="explore-filter__header">
                <span class="explore-filter__title">Filter</span>
                <span class="explore-filter__subtitle">by Region</span>
            </div>
            <div class="explore-filter__options">
                <button v-for="region in livableCityData.regionOptions" :key="region" type="button" class="explore-filter__btn"
                    :class="{ 'explore-filter__btn--active': isRegionActive(region) }" @click="toggleRegion(region)">
                    {{ region }}
                </button>
            </div>
        </div>

        <!-- Standards Filter -->
        <div class="explore-filter__section">
            <div v-if="standardsTopAd" class="explore-filter__ad-block">
                <AdComponent class="ad-width-100" :ads="standardsTopAd" :showDebug="showAdDebug"
                    :forceDebug="true" debugLabel="cities_ad_1"
                    debugPosition="by Top Standard 筛选项上方（仅移动端）" />
            </div>
            <div class="explore-filter__header">
                <span class="explore-filter__title">Filter</span>
                <span class="explore-filter__subtitle">by Top Standards</span>
            </div>
            <div class="explore-filter__options">
                <button v-for="standard in livableCityData.standardOptions" :key="standard.key" type="button" class="explore-filter__btn"
                    :class="{ 'explore-filter__btn--active': isStandardActive(standard.key) }"
                    @click="toggleStandard(standard.key)">
                    {{ standard.label }}
                </button>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AdComponent from '@/pages/components/AdComponent.vue'

export default {
    name: 'ExploreFilter',
    components: {
        AdComponent
    },
    props: {
        standardsTopAd: {
            type: Object,
            default: () => ({})
        },
        showAdDebug: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters(['livableCityData', 'livableCityFilters'])
    },
    created() {
        this.syncWithRouteQuery()
    },
    watch: {
        '$route.query': {
            handler() {
                this.syncWithRouteQuery()
            },
            deep: true
        }
    },
    methods: {
        isRegionActive(region) {
            return this.livableCityFilters.regions.includes(region)
        },
        isStandardActive(standard) {
            return this.livableCityFilters.standards.includes(standard)
        },
        toggleRegion(region) {
            const current = [...this.livableCityFilters.regions]
            const exists = current.includes(region)
            const next = exists ? current.filter((item) => item !== region) : [...current, region]
            this.$store.commit('setLivableCityFilters', { regions: next })
        },
        toggleStandard(standard) {
            const current = [...this.livableCityFilters.standards]
            const exists = current.includes(standard)
            const next = exists ? current.filter((item) => item !== standard) : [...current, standard]
            this.$store.commit('setLivableCityFilters', { standards: next })
        },
        syncWithRouteQuery() {
            const { region, standard } = this.$route.query
            if (!region && !standard) {
                return
            }
            const regionOptions = this.livableCityData.regionOptions || []
            const standardOptions = (this.livableCityData.standardOptions || []).map((item) => item.key)
            const queryRegions = String(region || '')
                .split(',')
                .map((item) => item.trim())
                .filter((item) => regionOptions.includes(item))
            const queryStandards = String(standard || '')
                .split(',')
                .map((item) => item.trim())
                .filter((item) => standardOptions.includes(item))
            this.$store.commit('setLivableCityFilters', {
                regions: queryRegions.length ? queryRegions : [...regionOptions],
                standards: queryStandards
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.explore-filter {
    display: flex;
    flex-direction: column;
    gap: rem(36);
    padding: 0 rem(20); // Mobile padding

    &__section {
        display: flex;
        flex-direction: column;
        gap: rem(12);
    }

    &__ad-block {
        width: 100%;
    }

    &__header {
        display: flex;
        flex-direction: column;
        gap: rem(4);
        font-family: $font-family-serif;
        color: #000;
    }

    &__title {
        font-weight: 700;
        font-style: italic;
        font-size: rem(20);
        line-height: rem(20);
    }

    &__subtitle {
        font-weight: 300;
        font-style: italic;
        font-size: rem(16);
        line-height: rem(16);
    }

    &__options {
        display: flex;
        flex-wrap: wrap;
        gap: rem(12) rem(8);
    }

    &__btn {
        padding: 0 rem(14);
        height: rem(32);
        border-radius: rem(100);
        border: 1px solid #fecd45;
        background: transparent;
        font-family: $font-family-serif;
        font-size: rem(13);
        color: #000;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s;

        &--active {
            background: #fecd45;
            border-color: #fecd45;
            font-weight: 500;
        }
    }
}

.detect_deviece_mobile {
    .explore-filter {
        &__header {
            flex-direction: row;
            align-items: baseline;
            gap: rem(8);
        }
    }
}

.detect_deviece_pc,
.detect_deviece_desktop {
    .explore-filter {
        &__btn {
            &:hover {
                background: #fecd45;
                border-color: #fecd45;
                font-weight: 500;
            }
        }
    }
}
</style>
